import { createAction } from '@reduxjs/toolkit';
import type { To } from 'react-router';

import type { LocationChangePayload } from './types/RouterState';

export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
const CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

export enum HistoryMethod {
  PUSH = 'push',
  REPLACE = 'replace',
  GO_BACK = 'goBack',
}

export type CallHistoryMethodPayload =
  | { method: HistoryMethod.PUSH | HistoryMethod.REPLACE; args: [To, unknown?] }
  | { method: HistoryMethod.GO_BACK; args: [] };

export const locationChange = createAction<LocationChangePayload>(LOCATION_CHANGE);

export const callHistoryMethod = createAction<CallHistoryMethodPayload>(CALL_HISTORY_METHOD);

export const push = (to: To, state?: unknown) => callHistoryMethod({
  method: HistoryMethod.PUSH,
  args: state === undefined ? [to] : [to, state],
});

export const replace = (to: To, state?: unknown) => callHistoryMethod({
  method: HistoryMethod.REPLACE,
  args: state === undefined ? [to] : [to, state],
});

export const goBack = () => callHistoryMethod({ method: HistoryMethod.GO_BACK, args: [] });
